import React, { useState, useLayoutEffect, useRef } from 'react';
import cn from "classnames";
import style from "./common.module.scss";
import CustomDatePicker from '../shared/date-picker/Date';
import CalendarIcon from '../shared/icons/CalendarIcon';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import {t} from "i18next";

const AnalyticsByCompareOrderPrice = ({ item, startDate, setStartDate }) => {
    const formatMonth = (monthString) => {
        const [month, year] = monthString.split('.');
        const date = new Date(year, month - 1);
        return date.toLocaleString('ru-RU', { month: 'short' });
    };

    useLayoutEffect(() => {
        let root = am5.Root.new('chartdiv-compare');
        root.setThemes([am5themes_Animated.new(root)]);

        root._logo.dispose();

        const formattedData = item.map(i => ({
            ...i,
            month: formatMonth(i.month),
        }));

        let chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                layout: root.verticalLayout,
                wheelY: "zoomX",
            })
        );

        chart.set("wheelable", true);

        let xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: 'month',
                renderer: am5xy.AxisRendererX.new(root, {
                    minGridDistance: 30,
                }),
            })
        );
        xAxis.data.setAll(formattedData);

        let yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                renderer: am5xy.AxisRendererY.new(root, {}),
            })
        );

        let priceSeries = chart.series.push(
            am5xy.LineSeries.new(root, {
                name: "Price",
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "price",
                categoryXField: "month",
                stroke: am5.color(0xFA1861), // 0xff0000
                fill: am5.color(0xFFEEEE),   // 0xffcccc
                // fillOpacity: 0.5,         
            })
        );
        priceSeries.data.setAll(formattedData);

        priceSeries.fills.template.setAll({
            visible: true,
            fillOpacity: 0.5,
        });

        let algoPriceSeries = chart.series.push(
            am5xy.LineSeries.new(root, {
                name: "AlgoPrice",
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "algoPrice",
                categoryXField: "month",
                stroke: am5.color(0x048848), // 0x00ff00
                fill: am5.color(0xE5FFEA),   // 0xccffcc
                // fillOpacity: 0.5,         
            })
        );
        algoPriceSeries.data.setAll(formattedData);

        algoPriceSeries.fills.template.setAll({
            visible: true,
            fillOpacity: 0.5,
        });

        return () => {
            root.dispose();
        };
    }, [item]);
    return (
        <div className={style.content}>
            <div className={style.filter}>
                <span className={style.filter_title}>{t('analytics.priceCompare')}</span>

                <CustomDatePicker
                    dateFormat="dd.MM.yyyy"
                    placeholderText={t('analytics.pickDate')}
                    withBorder
                    IconStart={<CalendarIcon />}
                    selected={startDate}
                    onChange={(date) => {
                        setStartDate(date);
                        console.log(date);
                    }}
                />
            </div>

            <div className={style.area}>
                <div id="chartdiv-compare" className={style.area_chart}></div>
                <div className={style.area_names}>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <div className={style.area_icon} style={{ backgroundColor: '#048848' }} ></div>
                        <div className={style.area_type}>{t('analytics.yourPrice')}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <div className={style.area_icon} style={{ backgroundColor: '#FA1861' }}></div>
                        <div className={style.area_type}>{t('analytics.algoPrice')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AnalyticsByCompareOrderPrice;
